module.exports = __webpack_public_path__ + "img/reference-schelling.804c03e6.jpg";